<ng-template let-type="type">
  <div
    [class.ds-bg-background-white]="
      type === 'blue-white' || type === 'grey-white'
    "
    [class.ds-bg-background-blue]="type === 'white-blue'"
    [class.ds-bg-background-grey]="type === 'white-grey'"
    class="
      slide-container
      ds-flex ds-flex-col ds-h-[100%] ds-mx-xs
      md:!ds-mx-[14px]
      lg:!ds-mx-[22px]
    "
  >
    <div
      class="
        image-container
        ds-flex ds-relative ds-overflow-hidden ds-h-[230px]
      "
    >
      <img
        [alt]="imageAlt"
        [src]="imageSrc"
        class="
          ds-object-cover ds-transition-all ds-h-full ds-aspect-[16/9]
          hover:ds-scale-105
          ds-flex-grow
        "
      />
    </div>
    <div
      class="
        content-container
        ds-flex ds-flex-col ds-flex-grow ds-px-xl ds-pt-xl ds-pb-2xl
        xl:!ds-px-2xl
      "
    >
      <ng-content select="[carouselSlideElementHeading]"></ng-content>
      <div
        class="
          content
          ds-flex-grow ds-mb-xl ds-text-base ds-leading-base ds-font-regular
        "
      >
        <ng-content select="[carouselSlideElementContent]"></ng-content>
      </div>
      <div class="button">
        <ng-content select="[carouselSlideElementCta]"></ng-content>
      </div>
    </div>
  </div>
</ng-template>
